export const receiverTypeNames: Record<string, string> = {
  pagerduty: 'PagerDuty',
  pushover: 'Pushover',
  slack: 'Slack',
  opsgenie: 'OpsGenie',
  webhook: 'Webhook',
  victorops: 'VictorOps',
  wechat: 'WeChat',
  discord: 'Discord',
  webex: 'Cisco Webex Teams',
  sns: 'Amazon SNS',
  telegram: 'Telegram',
  msteams: 'Microsoft Teams',
};
